export const getLikeValue = (value: string) => ({
  $ilike: `%${value}%`,
});
